import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { AlertController, Platform } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { isNil } from 'lodash-es';

import { MainTabBasePathEnum } from '../../enums/main-tabs';
import * as fromPropertyProfileActions from '../../store/actions/property-profile.actions';
import * as fromUserSelectors from '../../store/selectors/user.selectors';

@Injectable({
  providedIn: 'root'
})
export class VoiceAssistantService {
  private alertController = inject(AlertController);
  private platform = inject(Platform);
  private router = inject(Router);
  private store = inject(Store);

  isAuthenticated = false;
  constructor() {
    this.store.pipe(select(fromUserSelectors.selectLoaded)).subscribe((loaded) => {
      this.isAuthenticated = loaded;
    });
  }

  async init() {
    if (Capacitor.isNativePlatform() && this.platform.is('ios')) {
      await App.addListener('appUrlOpen', async (event) => {
        if (this.isAuthenticated) {
          try {
            const url = new URL(event.url);
            const address = url.searchParams.get('address');
            if (!isNil(address) && url.pathname === '/property-search') {
              await this.router.navigate([MainTabBasePathEnum.PropertySearch], {
                replaceUrl: true
              });
              this.store.dispatch(
                fromPropertyProfileActions.geocodeAddressLocation({
                  payload: { address }
                })
              );
            }
          } catch {
            const alertConfirm = await this.alertController.create({
              backdropDismiss: false,
              buttons: [
                {
                  role: 'cancel',
                  text: 'Ok'
                }
              ],
              header: 'Oops',
              message: `There was a issue using the voice assistant. Failed to parse the address.`
            });
            await alertConfirm.present();
          }
        } else {
          const alertConfirm = await this.alertController.create({
            backdropDismiss: false,
            buttons: [
              {
                role: 'cancel',
                text: 'Ok'
              }
            ],
            header: 'Not authenticated',
            message: `In order to use the voice assistant search, you need to authenticate first.`
          });
          await alertConfirm.present();
        }
      });
    }
  }
}
